import { Tramitacao } from '../../modules/types/Aquisicao';
import httpClient from '../httpClient';
export async function getAllTramitacoesPorEntidade(tab: string, id: number) {
  try {
    const response = await httpClient.get(`/api/tramitacoes/porentidade`, {
      params: {
        tab,
        id,
      },
    });
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}

export async function getTramitacoesByInstrumentoId(
  instrumentoId: number,
): Promise<Tramitacao[]> {
  try {
    const response = await httpClient.get(`/api/tramitacoes`, {
      params: {
        instrumentoId: instrumentoId,
      },
    });

    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Partes Envolvidas: ' + error);
  }
}

export async function handleCreateTramitacao(form: Tramitacao, tab: string) {
  try {
    return await httpClient.post(`/api/tramitacoes?tab=${tab}`, form);
  } catch (error) {
    throw error;
  }
}

export async function handleUpdateTramitacao(form: Tramitacao) {
  try {
    const response = await httpClient.patch(
      `/api/tramitacoes/${form.id}`,
      form,
    );

    return response;
  } catch (error) {
    throw error;
  }
}

export async function handleDeleteTramitacao(id: string | number) {
  try {
    return await httpClient.delete(`/api/tramitacoes/${id}`);
  } catch (error) {
    throw error;
  }
}
